<script setup lang="ts"></script>

<template>
  <div class="min-h-dvh bg-black text-white">
    <RouterView />
  </div>
</template>
